import classes from './SectionTitleH2.module.scss';

const SectionTitleH2 = (props) => {
    return <div className={classes.sectionTitleH2}>{props.children}</div>;
};

export default SectionTitleH2;
